import React, { useContext, useEffect } from "react";
import { useOldEngagementResponse } from "./store";
import { Card } from "antd";
import moment from "moment-timezone";
import { CustomerProps } from "./ShowCustomer";

function OldEngagementResponse() {
    const { fetchOldEngagementResponse, data } = useOldEngagementResponse();
    const { caseId } = useContext(CustomerProps);
 
    useEffect(() => {
        fetchOldEngagementResponse(caseId);
    }, [caseId]);

    const formatKey = (key) => {
        return key
            .replace(/([a-z])([A-Z])/g, '$1 $2') 
            .replace(/_/g, ' ') 
            .replace(/\b\w/g, char => char.toUpperCase());
    };
    const sortedData = Array.isArray(data)
        ? [...data].sort((a, b) => new Date(b.reminderDate) - new Date(a.reminderDate))
        : [];
    return (
        <div>
            {Array.isArray(data) &&
                sortedData.map((entry, index) => {
                    if (entry && typeof entry === "object") {
                        const reminderDate = entry.reminderDate
                            ? moment(entry.reminderDate).format('LLLL')
                            : "-";
                        const title = entry.tag ? `${entry.tag.toUpperCase()} ${reminderDate}` : "No Tag"

                        return (
                            <Card key={index} className="m-2" title={title} bordered={true}>
                                <p><strong>Reminder Date:</strong> {reminderDate}</p>
                                {Object.keys(entry).map(key => {
                                    if (key !== 'tag' && key !== 'engagementId' && key !== 'reminderDate') {
                                        return (
                                            <p key={key}><strong>{formatKey(key)}:</strong> {String(entry[key]) === "null" ? "-" : String(entry[key])}</p>
                                        );
                                    }
                                    return null;
                                })}
                            </Card>
                        );
                    }
                    return null;
                })}
        </div>
    );
}

export default OldEngagementResponse;
